import styled from '@emotion/styled';

// components
import Card from '@components/_atoms/Card';
import Divider from '@components/_atoms/Divider';
import Typography from '@components/_atoms/Typography';

// constants
import { TypoVariant } from '@constants/atoms';
import { primary } from '@styles/Colors';
import { useMemo } from 'react';
import { returnOnlyNumber } from '@utils/regex';

type Props = {
  title: string;
  titleOption?: React.ReactNode;
  height?: string;
  minHeight?: string;
  children: React.ReactNode;
};

const TitleWrapper = styled.div`
  margin-bottom: 16px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CardContent = styled.div<{ height?: string }>`
  margin-top: 16px;
  height: ${({ height }) => height || 'calc(100% - 60px)'};
  overflow-y: auto;
`;

export default function CardTemplates({ title, titleOption, height, minHeight, children }: Props) {
  const contentHeight = useMemo(() => {
    if (height) {
      return returnOnlyNumber(height) - 60 + 'px';
    }
    if (minHeight) {
      return returnOnlyNumber(minHeight) - 60 + 'px';
    }
  }, [height, minHeight]);

  return (
    <Card style={{ height, minHeight }} backgroundWhite>
      <TitleWrapper>
        <Typography variant={TypoVariant.SH2} color={primary.gray}>
          {title}
        </Typography>

        {titleOption}
      </TitleWrapper>

      <Divider />

      <CardContent height={contentHeight}>{children}</CardContent>
    </Card>
  );
}
